import { useDanceStore } from '../store/useDanceStore';
import { MANNEQUIN_DIMENSIONS } from '../utils/dimensions';
import { solveLimbIK } from '../utils/ikSolver';
import { fetchWithAuth } from '../lib/api';

export async function fetchPoseDataFromText(text: string, token: string) {
  const currentPose = useDanceStore.getState().currentPose;
  
  return await fetchWithAuth('/api/text-to-pose', {
    method: 'POST',
    headers: {
      'x-recaptcha-token': token
    },
    body: JSON.stringify({
      prompt: text,
      currentPose,
      model: 'gemini-3.5-flash'
    })
  });
}

export function applyPoseData(data: any) {
  const { isMirroring, setJointRotation } = useDanceStore.getState();
  if (isMirroring) useDanceStore.setState({ isMirroring: false });

  // 1. Apply Core Angles (Forward Kinematics)
  if (data.core_angles) {
    Object.entries(data.core_angles).forEach(([jointName, angles]: [string, any]) => {
      if (angles && typeof angles.x === 'number') {
        setJointRotation(jointName, angles.x, angles.y, angles.z);
      }
    });
  }
  
  // 2. Apply IK Targets (Inverse Kinematics)
  if (data.ik_targets) {
    const targets = data.ik_targets;
    const poles = data.pole_vectors || {};

    const resolveLimb = (
      target: any, pole: any, 
      rootName: string, hingeName: string, 
      l1: number, l2: number
    ) => {
      if (target && typeof target.x === 'number') {
        const { rootAngles, hingeAngles } = solveLimbIK(
          rootName, hingeName, 
          target, l1, l2, pole
        );
        setJointRotation(rootName, rootAngles[0], rootAngles[1], rootAngles[2]);
        setJointRotation(hingeName, hingeAngles[0], hingeAngles[1], hingeAngles[2]);
      }
    };

    resolveLimb(targets.leftWrist, poles.leftElbow, 'leftShoulder', 'leftElbow', MANNEQUIN_DIMENSIONS.upperArmLen, MANNEQUIN_DIMENSIONS.lowerArmLen);
    resolveLimb(targets.rightWrist, poles.rightElbow, 'rightShoulder', 'rightElbow', MANNEQUIN_DIMENSIONS.upperArmLen, MANNEQUIN_DIMENSIONS.lowerArmLen);
    resolveLimb(targets.leftAnkle, poles.leftKnee, 'leftHip', 'leftKnee', MANNEQUIN_DIMENSIONS.upperLegLen, MANNEQUIN_DIMENSIONS.lowerLegLen);
    resolveLimb(targets.rightAnkle, poles.rightKnee, 'rightHip', 'rightKnee', MANNEQUIN_DIMENSIONS.upperLegLen, MANNEQUIN_DIMENSIONS.lowerLegLen);
  }

  if (isMirroring) useDanceStore.setState({ isMirroring: true });
}

export async function generatePoseFromText(text: string, token: string) {
  const data = await fetchPoseDataFromText(text, token);
  applyPoseData(data);
  return data;
}
